<template>
  <div class="page homepage boxes">
    <header>
      <div></div><div  class="view-title"></div>

      <button @click="goTo('/cart')" v-if="cartLength" :aria-label="dictValue('CartWithItems', {nitems: cartLength})">
        <i class="fa fa-fw fa-shopping-cart" :badge="cartLengthLabel"></i>
      </button>

    </header>
    <div style="margin-top: -30px;padding-top: 0rem;" class="noheader" v-if="isMobile">
      <img src="/img/logo.png"  class="logo" alt="logo" />
  
      <button @click="checkLoginAndGoTo('/producttypes')" class="withicon" :disabled="!isConnected">
        <span class="iconbox">
          <i v-if="isAutoLogging && loggingFor === '/producttypes'" class="fa fa-fw fa-refresh fa-spin"></i>
          <img v-else src="@/assets/icons/credit_pad.svg" :alt="dictValue('BuyMenu') + ' icon'" />
          <!-- <i class="fa fa-fw" :class="isAutoLogging && loggingFor === '/producttypes' ? 'fa-refresh fa-spin' : 'fa-plus'"></i> -->
        </span>
        <span>{{ 'BuyMenu' | lang }}</span>
      </button>
      <button @click="goTo('/mytickets')"  v-if="!manifest.hideQrcodeTickets" class="withicon reverse">
        <span class="iconbox">
          <img src="@/assets/icons/qr.svg" :alt="dictValue('MyTickets') + ' icon'" />
        </span>
        <span>{{ 'MyTickets' | lang }}</span>
      </button>
      <button @click="goTo('/tripplanner')" class="withicon" v-if="!manifest.hideTripPlanner" :disabled="!isConnected">
        <span class="iconbox">
          <img src="@/assets/icons/map.svg" :alt="dictValue('TripPlanner') + ' icon'" />
        </span>
        <span>{{ 'TripPlanner' | lang }}</span>
      </button>
      <button @click="goTo('/stopcalls')" class="withicon reverse" v-if="!manifest.hideNextPassages" :disabled="!isConnected">
        <span class="iconbox">
          <img src="@/assets/icons/stops_pad.svg" :alt="dictValue('StopCalls') + ' icon'" />
        </span>
        <span>{{ 'StopCalls' | lang }}</span>
      </button>
      <button @click="checkFullLoginAndGoTo('/account')" class="withicon" :disabled="!isConnected && !isFullLogged">
        <span class="iconbox">
          <img src="@/assets/icons/user_pad.svg" :alt="dictValue(isFullLogged ? 'EditAccount' : 'login') + ' icon'" />
        </span>
        <span>{{ (isFullLogged ? 'EditAccount' : 'login') | lang }}</span>
      </button>
      <div>&nbsp;</div>
    </div>
    <div class="noheader" v-else>
      <button @click="checkFullLoginAndGoTo('/producttypes')" class="withicon">
        <span class="iconbox">
          <i v-if="isAutoLogging && loggingFor === '/producttypes'" class="fa fa-fw fa-refresh fa-spin"></i>
          <img v-else src="@/assets/icons/credit.svg" style="padding: .4rem !important" :alt="dictValue('BuyMenu') + ' icon'" />
        </span>
        <span>{{ 'BuyMenu' | lang }}</span>
      </button>
      <button @click="goTo('/tripplanner')" class="withicon" v-if="!manifest.hideTripPlanner">
        <span class="iconbox">
          <img src="@/assets/icons/map.svg" :alt="dictValue('TripPlanner') + ' icon'" />
        </span>
        <span>{{ 'TripPlanner' | lang }}</span>
      </button>
      <button @click="goTo('/stopcalls')" class="withicon" v-if="!manifest.hideNextPassages">
        <span class="iconbox" style="padding: .5rem !important">
          <img src="@/assets/icons/stops.svg" :alt="dictValue('StopCalls') + ' icon'" />
        </span>
        <span>{{ 'StopCalls' | lang }}</span>
      </button>
      <button @click="checkFullLoginAndGoTo('/account')" class="withicon">
        <span class="iconbox">
          <img src="@/assets/icons/user_pad.svg" :alt="dictValue(isFullLogged ? 'EditAccount' : 'login') + ' icon'" />
        </span>
        <span>{{ (isFullLogged ? 'EditAccount' : 'login') | lang }}</span>
      </button>
    </div>
    <footer>
      <div>
        <button @click="goTo('/settings')" :aria-label="dictValue('Settings')"><i class="fa fa-fw fa-wrench"></i></button>
        <button @click="goTo('/help')" :aria-label="dictValue('Help')"><i class="fa fa-fw fa-question"></i></button>
        <button @click="goTo('/extramobilepage')" v-if="extraMobilePage" :aria-label="dictValue('MoreInfos')"><i class="fa fa-fw fa-info"></i></button>
      <!--  <button @click="goTo('/cart')" v-if="cartLength" :aria-label="dictValue('CartWithItems', {nitems: cartLength})">
          <i class="fa fa-fw fa-shopping-cart" :badge="cartLengthLabel"></i>
        </button>-->
      </div>
      <div style="font-size:80%;align-self:flex-end;margin-bottom:0.1rem">{{ 'version' | lang(null, { version: '1.0.16' }) }}</div>
    </footer>
  </div>
</template>

<script>
import page from '@/mixins/routeControl'
import databaseWrapperMixin from '@/mixins/databaseWrapperMixin'
import UserServices from '@/mixins/services/userServices'

export default {
  name: 'Homepage',
  mixins: [ page, databaseWrapperMixin, UserServices ],
  computed: {
    urlParams () {
      return { email: this.$route.query.email, registrationToken: this.$route.query.token }
    }
  },
  watch: {
    async 'manifest.isLoaded' (newV) {
      if (newV) {
        if (this.urlParams.registrationToken) {
        this.user = await this._doAnonymousLogin()
        this._completeRegistration(this.urlParams.email, this.urlParams.registrationToken).then(response => {
          console.log(response)
          this.internalBus.$emit('notify:success', {
            text: this.dictValue('EmailVerificationOk'),
            key: this.notifierKey
          })
          this.goTo('/', true)
        }).catch(e => {
          console.warn(e)
          this.internalBus.$emit('notify:error', {
            text: this.dictValue('errorOccured') + (e.status === 418 ? '[VAD]' : ''),
            key: this.notifierKey,
            timeout: 3000
          })
        })
      }
      }
    }
  }
}
</script>

<style lang="scss">
.logo {
  //width: calc(100% - 3rem);
  //margin: 1.5rem auto;
  width: calc(40%);
  margin: 40px auto;
  flex: 0 0 auto !important;
  // flex: 1 1 auto;
}
.homepage .nav {
  margin: auto 0;
}
.homepage .noheader {
  justify-content: space-between;

  & > button {
    margin: auto;
    flex: 0 1 auto;
    margin: .5rem 1.5rem;
    height: 20vw;
    font-size: 1.3rem;
  }
}

</style>
